import { render } from "./oficialiaMenu.vue?vue&type=template&id=0d974814&scoped=true"
import script from "./oficialiaMenu.vue?vue&type=script&lang=js"
export * from "./oficialiaMenu.vue?vue&type=script&lang=js"

import "./oficialiaMenu.vue?vue&type=style&index=0&id=0d974814&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d974814"]])

export default __exports__